// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/style/index.style.scss
// module id = 812
// module chunks = 1